import type { BannerVariant, MixOrderIssueCode, MixOrderIssueSeverity } from './types';

export const TEST_ID = 'mixOrderAdvisoryPanel';

export const FORMULATION_UNKNOWN_ISSUE_CODE: MixOrderIssueCode = 'FORMULATION_UNKNOWN';

export const SEVERITY_TO_BANNER_VARIANT: Record<MixOrderIssueSeverity, BannerVariant> = {
    BLOCKED: 'warn',
    INFO: 'info',
    WARNING: 'warn'
};
